"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoamingSettingIdMap = void 0;
exports.RoamingSettingIdMap = {
    CampaignStates: 1258,
    GovernedChannelStates: 1257,
    SurveyActivationStats: 1259,
};
